import script from "./QuestionLists.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionLists.vue?vue&type=script&setup=true&lang=js"

import "./QuestionLists.vue?vue&type=style&index=0&id=c31ad508&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c31ad508"]])

export default __exports__